webpackJsonp([32239989425883],{

/***/ "./src/components/About/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	__webpack_require__("./src/components/About/styles.sass");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	var _Commons = __webpack_require__("./src/components/Shared/Commons.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------	Plugins
	
	
	//---------	Styles
	
	
	//---------	Translations
	
	
	//---------	Commons
	
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, About);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.throttledMatchHeight = (0, _lodash.throttle)(_this.aboutMatchHeight, 300), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //---------	React functions
	  About.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(this.throttledMatchHeight, 300);
	    window.addEventListener('resize', this.throttledMatchHeight);
	  };
	
	  About.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.throttledMatchHeight);
	  };
	
	  //---------	Custom functions
	
	
	  About.prototype.aboutMatchHeight = function aboutMatchHeight() {
	    (0, _Commons.matchHeight)('.alt .CalipsyAbout-container');
	  };
	
	  //---------	Render
	
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'CalipsyAbout' },
	      _react2.default.createElement(
	        'article',
	        { className: 'CalipsyAbout-row history' },
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyAbout-container' },
	            _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: _translations.T.about.historyTitle } }),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _translations.T.about.historyContent } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'article',
	        { className: 'CalipsyAbout-row alt' },
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyAbout-container' },
	            _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: _translations.T.about.whatWeDoTitle } }),
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _translations.T.about.whatWeDoContent } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyAbout-container' },
	            _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: _translations.T.about.missionTitle } }),
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _translations.T.about.missionContent } })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'article',
	        { className: 'CalipsyAbout-row process' },
	        _react2.default.createElement(
	          'div',
	          { className: 'CalipsyContainer' },
	          _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: _translations.T.about.process.title } })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'CalipsyAbout-process' },
	        _react2.default.createElement(
	          'article',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'CalipsyAbout-step' },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _translations.T.about.process.step1 } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'CalipsyAbout-step' },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _translations.T.about.process.step2 } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'CalipsyAbout-step' },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _translations.T.about.process.step3 } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'article',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'CalipsyContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'CalipsyAbout-step' },
	              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _translations.T.about.process.step4 } })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/About/styles.sass":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Shared/Commons.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.matchHeight = matchHeight;
	exports.onTemplateLoad = onTemplateLoad;
	function matchHeight(selector) {
	  var element = document.querySelectorAll(selector);
	  var height = 0,
	      width = void 0,
	      parentWidth = void 0,
	      fullWidth = false,
	      b = void 0;
	
	  for (var i = 0; i < element.length; i++) {
	    element[i].style.height = 'auto';
	  }
	
	  for (var _i = 0; _i < element.length; _i++) {
	    b = element[_i];
	    parentWidth = b.parentNode.offsetWidth;
	    width = b.offsetWidth;
	    if (parentWidth < width + 40) {
	      fullWidth = true;
	      break;
	    }
	
	    height = b.offsetHeight > height ? b.offsetHeight : height;
	  }
	
	  for (var _i2 = 0; _i2 < element.length; _i2++) {
	    element[_i2].style.height = fullWidth ? 'auto' : height + 'px';
	  }
	}
	
	function onTemplateLoad() {
	  window.scrollTo(0, 0);
	}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"D:/projekty/Calipsy/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"D:/projekty/Calipsy/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"D:/projekty/Calipsy/node_modules/babel-preset-stage-0/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/about.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Commons = __webpack_require__("./src/Components/Shared/Commons.js");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	var _Banner = __webpack_require__("./src/components/Banner/index.js");
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _About = __webpack_require__("./src/components/About/index.js");
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Newsletter = __webpack_require__("./src/components/Newsletter/index.js");
	
	var _Newsletter2 = _interopRequireDefault(_Newsletter);
	
	var _SEO = __webpack_require__("./src/components/SEO/index.js");
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------  Plugins
	
	
	//---------	Translations
	
	
	//---------	Components
	
	
	var AboutTemplate = function (_React$Component) {
	  _inherits(AboutTemplate, _React$Component);
	
	  //---------	Constructor
	  function AboutTemplate() {
	    _classCallCheck(this, AboutTemplate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  AboutTemplate.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ loading: false });
	    }, 300);
	    setTimeout(function () {
	      return (0, _Commons.onTemplateLoad)();
	    });
	  };
	
	  AboutTemplate.prototype.render = function render() {
	    var data = this.props.data.markdownRemark.frontmatter;
	    var seo = {
	      title: _translations.T.SEO.title.about + ' - ' + data.title + ' | Calipsy'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper' },
	      _react2.default.createElement(_SEO2.default, seo),
	      _react2.default.createElement('div', { className: 'CalipsySpinner' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsyWrapper-container' },
	        _react2.default.createElement(_Banner2.default, { data: data.banner }),
	        _react2.default.createElement(_About2.default, null),
	        _react2.default.createElement(_Newsletter2.default, null)
	      )
	    );
	  };
	
	  return AboutTemplate;
	}(_react2.default.Component);
	
	exports.default = AboutTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-js-d3642105958d8b841955.js